import React, { FC, HTMLProps, ElementType } from 'react';
import classNames from 'classnames';
import styles from './chip.module.scss';
import { Hyperlink } from '../Hyperlink';

type CustomComponentProps = HTMLProps<
  typeof Hyperlink | HTMLButtonElement | HTMLSpanElement
>;
interface Props extends CustomComponentProps {
  component?: ElementType;
  color: 'secondary' | 'success' | 'warning' | 'future' | 'primary';
  className?: string;
  'data-test-id'?: string;
}

export const Chip: FC<Props> = ({
  color,

  component: Component = 'span',
  children,
  className,
  ...props
}) => {
  return (
    <Component
      {...props}
      className={classNames(styles.container, className, {
        [styles.secondary]: color === 'secondary',
        [styles.success]: color === 'success',
        [styles.warning]: color === 'warning',
        [styles.future]: color === 'future',
        [styles.primary]: color === 'primary',
        [styles.clickable]: Component === Hyperlink || Component === 'button',
      })}
      data-test-id={props['data-test-id']}
    >
      {children}
    </Component>
  );
};
